module.exports={
  "af": {
    "and": [
      "* ",
      "En "
    ],
    "background": [
      "Agtergrond"
    ],
    "but": [
      "* ",
      "Maar "
    ],
    "examples": [
      "Voorbeelde"
    ],
    "feature": [
      "Funksie",
      "Besigheid Behoefte",
      "Vermoë"
    ],
    "given": [
      "* ",
      "Gegewe "
    ],
    "name": "Afrikaans",
    "native": "Afrikaans",
    "scenario": [
      "Situasie"
    ],
    "scenarioOutline": [
      "Situasie Uiteensetting"
    ],
    "then": [
      "* ",
      "Dan "
    ],
    "when": [
      "* ",
      "Wanneer "
    ]
  },
  "am": {
    "and": [
      "* ",
      "Եվ "
    ],
    "background": [
      "Կոնտեքստ"
    ],
    "but": [
      "* ",
      "Բայց "
    ],
    "examples": [
      "Օրինակներ"
    ],
    "feature": [
      "Ֆունկցիոնալություն",
      "Հատկություն"
    ],
    "given": [
      "* ",
      "Դիցուք "
    ],
    "name": "Armenian",
    "native": "հայերեն",
    "scenario": [
      "Սցենար"
    ],
    "scenarioOutline": [
      "Սցենարի կառուցվացքը"
    ],
    "then": [
      "* ",
      "Ապա "
    ],
    "when": [
      "* ",
      "Եթե ",
      "Երբ "
    ]
  },
  "ar": {
    "and": [
      "* ",
      "و "
    ],
    "background": [
      "الخلفية"
    ],
    "but": [
      "* ",
      "لكن "
    ],
    "examples": [
      "امثلة"
    ],
    "feature": [
      "خاصية"
    ],
    "given": [
      "* ",
      "بفرض "
    ],
    "name": "Arabic",
    "native": "العربية",
    "scenario": [
      "سيناريو"
    ],
    "scenarioOutline": [
      "سيناريو مخطط"
    ],
    "then": [
      "* ",
      "اذاً ",
      "ثم "
    ],
    "when": [
      "* ",
      "متى ",
      "عندما "
    ]
  },
  "bg": {
    "and": [
      "* ",
      "И "
    ],
    "background": [
      "Предистория"
    ],
    "but": [
      "* ",
      "Но "
    ],
    "examples": [
      "Примери"
    ],
    "feature": [
      "Функционалност"
    ],
    "given": [
      "* ",
      "Дадено "
    ],
    "name": "Bulgarian",
    "native": "български",
    "scenario": [
      "Сценарий"
    ],
    "scenarioOutline": [
      "Рамка на сценарий"
    ],
    "then": [
      "* ",
      "То "
    ],
    "when": [
      "* ",
      "Когато "
    ]
  },
  "bm": {
    "and": [
      "* ",
      "Dan "
    ],
    "background": [
      "Latar Belakang"
    ],
    "but": [
      "* ",
      "Tetapi ",
      "Tapi "
    ],
    "examples": [
      "Contoh"
    ],
    "feature": [
      "Fungsi"
    ],
    "given": [
      "* ",
      "Diberi ",
      "Bagi "
    ],
    "name": "Malay",
    "native": "Bahasa Melayu",
    "scenario": [
      "Senario",
      "Situasi",
      "Keadaan"
    ],
    "scenarioOutline": [
      "Kerangka Senario",
      "Kerangka Situasi",
      "Kerangka Keadaan",
      "Garis Panduan Senario"
    ],
    "then": [
      "* ",
      "Maka ",
      "Kemudian "
    ],
    "when": [
      "* ",
      "Apabila "
    ]
  },
  "bs": {
    "and": [
      "* ",
      "I ",
      "A "
    ],
    "background": [
      "Pozadina"
    ],
    "but": [
      "* ",
      "Ali "
    ],
    "examples": [
      "Primjeri"
    ],
    "feature": [
      "Karakteristika"
    ],
    "given": [
      "* ",
      "Dato "
    ],
    "name": "Bosnian",
    "native": "Bosanski",
    "scenario": [
      "Scenariju",
      "Scenario"
    ],
    "scenarioOutline": [
      "Scenariju-obris",
      "Scenario-outline"
    ],
    "then": [
      "* ",
      "Zatim "
    ],
    "when": [
      "* ",
      "Kada "
    ]
  },
  "ca": {
    "and": [
      "* ",
      "I "
    ],
    "background": [
      "Rerefons",
      "Antecedents"
    ],
    "but": [
      "* ",
      "Però "
    ],
    "examples": [
      "Exemples"
    ],
    "feature": [
      "Característica",
      "Funcionalitat"
    ],
    "given": [
      "* ",
      "Donat ",
      "Donada ",
      "Atès ",
      "Atesa "
    ],
    "name": "Catalan",
    "native": "català",
    "scenario": [
      "Escenari"
    ],
    "scenarioOutline": [
      "Esquema de l'escenari"
    ],
    "then": [
      "* ",
      "Aleshores ",
      "Cal "
    ],
    "when": [
      "* ",
      "Quan "
    ]
  },
  "cs": {
    "and": [
      "* ",
      "A také ",
      "A "
    ],
    "background": [
      "Pozadí",
      "Kontext"
    ],
    "but": [
      "* ",
      "Ale "
    ],
    "examples": [
      "Příklady"
    ],
    "feature": [
      "Požadavek"
    ],
    "given": [
      "* ",
      "Pokud ",
      "Za předpokladu "
    ],
    "name": "Czech",
    "native": "Česky",
    "scenario": [
      "Scénář"
    ],
    "scenarioOutline": [
      "Náčrt Scénáře",
      "Osnova scénáře"
    ],
    "then": [
      "* ",
      "Pak "
    ],
    "when": [
      "* ",
      "Když "
    ]
  },
  "cy-GB": {
    "and": [
      "* ",
      "A "
    ],
    "background": [
      "Cefndir"
    ],
    "but": [
      "* ",
      "Ond "
    ],
    "examples": [
      "Enghreifftiau"
    ],
    "feature": [
      "Arwedd"
    ],
    "given": [
      "* ",
      "Anrhegedig a "
    ],
    "name": "Welsh",
    "native": "Cymraeg",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Scenario Amlinellol"
    ],
    "then": [
      "* ",
      "Yna "
    ],
    "when": [
      "* ",
      "Pryd "
    ]
  },
  "da": {
    "and": [
      "* ",
      "Og "
    ],
    "background": [
      "Baggrund"
    ],
    "but": [
      "* ",
      "Men "
    ],
    "examples": [
      "Eksempler"
    ],
    "feature": [
      "Egenskab"
    ],
    "given": [
      "* ",
      "Givet "
    ],
    "name": "Danish",
    "native": "dansk",
    "scenario": [
      "Scenarie"
    ],
    "scenarioOutline": [
      "Abstrakt Scenario"
    ],
    "then": [
      "* ",
      "Så "
    ],
    "when": [
      "* ",
      "Når "
    ]
  },
  "de": {
    "and": [
      "* ",
      "Und "
    ],
    "background": [
      "Grundlage"
    ],
    "but": [
      "* ",
      "Aber "
    ],
    "examples": [
      "Beispiele"
    ],
    "feature": [
      "Funktionalität"
    ],
    "given": [
      "* ",
      "Angenommen ",
      "Gegeben sei ",
      "Gegeben seien "
    ],
    "name": "German",
    "native": "Deutsch",
    "scenario": [
      "Szenario"
    ],
    "scenarioOutline": [
      "Szenariogrundriss"
    ],
    "then": [
      "* ",
      "Dann "
    ],
    "when": [
      "* ",
      "Wenn "
    ]
  },
  "el": {
    "and": [
      "* ",
      "Και "
    ],
    "background": [
      "Υπόβαθρο"
    ],
    "but": [
      "* ",
      "Αλλά "
    ],
    "examples": [
      "Παραδείγματα",
      "Σενάρια"
    ],
    "feature": [
      "Δυνατότητα",
      "Λειτουργία"
    ],
    "given": [
      "* ",
      "Δεδομένου "
    ],
    "name": "Greek",
    "native": "Ελληνικά",
    "scenario": [
      "Σενάριο"
    ],
    "scenarioOutline": [
      "Περιγραφή Σεναρίου"
    ],
    "then": [
      "* ",
      "Τότε "
    ],
    "when": [
      "* ",
      "Όταν "
    ]
  },
  "em": {
    "and": [
      "* ",
      "😂"
    ],
    "background": [
      "💤"
    ],
    "but": [
      "* ",
      "😔"
    ],
    "examples": [
      "📓"
    ],
    "feature": [
      "📚"
    ],
    "given": [
      "* ",
      "😐"
    ],
    "name": "Emoji",
    "native": "😀",
    "scenario": [
      "📕"
    ],
    "scenarioOutline": [
      "📖"
    ],
    "then": [
      "* ",
      "🙏"
    ],
    "when": [
      "* ",
      "🎬"
    ]
  },
  "en": {
    "and": [
      "* ",
      "And "
    ],
    "background": [
      "Background"
    ],
    "but": [
      "* ",
      "But "
    ],
    "examples": [
      "Examples",
      "Scenarios"
    ],
    "feature": [
      "Feature",
      "Business Need",
      "Ability"
    ],
    "given": [
      "* ",
      "Given "
    ],
    "name": "English",
    "native": "English",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Scenario Outline",
      "Scenario Template"
    ],
    "then": [
      "* ",
      "Then "
    ],
    "when": [
      "* ",
      "When "
    ]
  },
  "en-Scouse": {
    "and": [
      "* ",
      "An "
    ],
    "background": [
      "Dis is what went down"
    ],
    "but": [
      "* ",
      "Buh "
    ],
    "examples": [
      "Examples"
    ],
    "feature": [
      "Feature"
    ],
    "given": [
      "* ",
      "Givun ",
      "Youse know when youse got "
    ],
    "name": "Scouse",
    "native": "Scouse",
    "scenario": [
      "The thing of it is"
    ],
    "scenarioOutline": [
      "Wharrimean is"
    ],
    "then": [
      "* ",
      "Dun ",
      "Den youse gotta "
    ],
    "when": [
      "* ",
      "Wun ",
      "Youse know like when "
    ]
  },
  "en-au": {
    "and": [
      "* ",
      "Too right "
    ],
    "background": [
      "First off"
    ],
    "but": [
      "* ",
      "Yeah nah "
    ],
    "examples": [
      "You'll wanna"
    ],
    "feature": [
      "Pretty much"
    ],
    "given": [
      "* ",
      "Y'know "
    ],
    "name": "Australian",
    "native": "Australian",
    "scenario": [
      "Awww, look mate"
    ],
    "scenarioOutline": [
      "Reckon it's like"
    ],
    "then": [
      "* ",
      "But at the end of the day I reckon "
    ],
    "when": [
      "* ",
      "It's just unbelievable "
    ]
  },
  "en-lol": {
    "and": [
      "* ",
      "AN "
    ],
    "background": [
      "B4"
    ],
    "but": [
      "* ",
      "BUT "
    ],
    "examples": [
      "EXAMPLZ"
    ],
    "feature": [
      "OH HAI"
    ],
    "given": [
      "* ",
      "I CAN HAZ "
    ],
    "name": "LOLCAT",
    "native": "LOLCAT",
    "scenario": [
      "MISHUN"
    ],
    "scenarioOutline": [
      "MISHUN SRSLY"
    ],
    "then": [
      "* ",
      "DEN "
    ],
    "when": [
      "* ",
      "WEN "
    ]
  },
  "en-old": {
    "and": [
      "* ",
      "Ond ",
      "7 "
    ],
    "background": [
      "Aer",
      "Ær"
    ],
    "but": [
      "* ",
      "Ac "
    ],
    "examples": [
      "Se the",
      "Se þe",
      "Se ðe"
    ],
    "feature": [
      "Hwaet",
      "Hwæt"
    ],
    "given": [
      "* ",
      "Thurh ",
      "Þurh ",
      "Ðurh "
    ],
    "name": "Old English",
    "native": "Englisc",
    "scenario": [
      "Swa"
    ],
    "scenarioOutline": [
      "Swa hwaer swa",
      "Swa hwær swa"
    ],
    "then": [
      "* ",
      "Tha ",
      "Þa ",
      "Ða ",
      "Tha the ",
      "Þa þe ",
      "Ða ðe "
    ],
    "when": [
      "* ",
      "Tha ",
      "Þa ",
      "Ða "
    ]
  },
  "en-pirate": {
    "and": [
      "* ",
      "Aye "
    ],
    "background": [
      "Yo-ho-ho"
    ],
    "but": [
      "* ",
      "Avast! "
    ],
    "examples": [
      "Dead men tell no tales"
    ],
    "feature": [
      "Ahoy matey!"
    ],
    "given": [
      "* ",
      "Gangway! "
    ],
    "name": "Pirate",
    "native": "Pirate",
    "scenario": [
      "Heave to"
    ],
    "scenarioOutline": [
      "Shiver me timbers"
    ],
    "then": [
      "* ",
      "Let go and haul "
    ],
    "when": [
      "* ",
      "Blimey! "
    ]
  },
  "eo": {
    "and": [
      "* ",
      "Kaj "
    ],
    "background": [
      "Fono"
    ],
    "but": [
      "* ",
      "Sed "
    ],
    "examples": [
      "Ekzemploj"
    ],
    "feature": [
      "Trajto"
    ],
    "given": [
      "* ",
      "Donitaĵo ",
      "Komence "
    ],
    "name": "Esperanto",
    "native": "Esperanto",
    "scenario": [
      "Scenaro",
      "Kazo"
    ],
    "scenarioOutline": [
      "Konturo de la scenaro",
      "Skizo",
      "Kazo-skizo"
    ],
    "then": [
      "* ",
      "Do "
    ],
    "when": [
      "* ",
      "Se "
    ]
  },
  "es": {
    "and": [
      "* ",
      "Y ",
      "E "
    ],
    "background": [
      "Antecedentes"
    ],
    "but": [
      "* ",
      "Pero "
    ],
    "examples": [
      "Ejemplos"
    ],
    "feature": [
      "Característica"
    ],
    "given": [
      "* ",
      "Dado ",
      "Dada ",
      "Dados ",
      "Dadas "
    ],
    "name": "Spanish",
    "native": "español",
    "scenario": [
      "Escenario"
    ],
    "scenarioOutline": [
      "Esquema del escenario"
    ],
    "then": [
      "* ",
      "Entonces "
    ],
    "when": [
      "* ",
      "Cuando "
    ]
  },
  "et": {
    "and": [
      "* ",
      "Ja "
    ],
    "background": [
      "Taust"
    ],
    "but": [
      "* ",
      "Kuid "
    ],
    "examples": [
      "Juhtumid"
    ],
    "feature": [
      "Omadus"
    ],
    "given": [
      "* ",
      "Eeldades "
    ],
    "name": "Estonian",
    "native": "eesti keel",
    "scenario": [
      "Stsenaarium"
    ],
    "scenarioOutline": [
      "Raamstsenaarium"
    ],
    "then": [
      "* ",
      "Siis "
    ],
    "when": [
      "* ",
      "Kui "
    ]
  },
  "fa": {
    "and": [
      "* ",
      "و "
    ],
    "background": [
      "زمینه"
    ],
    "but": [
      "* ",
      "اما "
    ],
    "examples": [
      "نمونه ها"
    ],
    "feature": [
      "وِیژگی"
    ],
    "given": [
      "* ",
      "با فرض "
    ],
    "name": "Persian",
    "native": "فارسی",
    "scenario": [
      "سناریو"
    ],
    "scenarioOutline": [
      "الگوی سناریو"
    ],
    "then": [
      "* ",
      "آنگاه "
    ],
    "when": [
      "* ",
      "هنگامی "
    ]
  },
  "fi": {
    "and": [
      "* ",
      "Ja "
    ],
    "background": [
      "Tausta"
    ],
    "but": [
      "* ",
      "Mutta "
    ],
    "examples": [
      "Tapaukset"
    ],
    "feature": [
      "Ominaisuus"
    ],
    "given": [
      "* ",
      "Oletetaan "
    ],
    "name": "Finnish",
    "native": "suomi",
    "scenario": [
      "Tapaus"
    ],
    "scenarioOutline": [
      "Tapausaihio"
    ],
    "then": [
      "* ",
      "Niin "
    ],
    "when": [
      "* ",
      "Kun "
    ]
  },
  "fr": {
    "and": [
      "* ",
      "Et que ",
      "Et qu'",
      "Et "
    ],
    "background": [
      "Contexte"
    ],
    "but": [
      "* ",
      "Mais que ",
      "Mais qu'",
      "Mais "
    ],
    "examples": [
      "Exemples"
    ],
    "feature": [
      "Fonctionnalité"
    ],
    "given": [
      "* ",
      "Soit ",
      "Etant donné que ",
      "Etant donné qu'",
      "Etant donné ",
      "Etant donnée ",
      "Etant donnés ",
      "Etant données ",
      "Étant donné que ",
      "Étant donné qu'",
      "Étant donné ",
      "Étant donnée ",
      "Étant donnés ",
      "Étant données "
    ],
    "name": "French",
    "native": "français",
    "scenario": [
      "Scénario"
    ],
    "scenarioOutline": [
      "Plan du scénario",
      "Plan du Scénario"
    ],
    "then": [
      "* ",
      "Alors "
    ],
    "when": [
      "* ",
      "Quand ",
      "Lorsque ",
      "Lorsqu'"
    ]
  },
  "ga": {
    "and": [
      "* ",
      "Agus"
    ],
    "background": [
      "Cúlra"
    ],
    "but": [
      "* ",
      "Ach"
    ],
    "examples": [
      "Samplaí"
    ],
    "feature": [
      "Gné"
    ],
    "given": [
      "* ",
      "Cuir i gcás go",
      "Cuir i gcás nach",
      "Cuir i gcás gur",
      "Cuir i gcás nár"
    ],
    "name": "Irish",
    "native": "Gaeilge",
    "scenario": [
      "Cás"
    ],
    "scenarioOutline": [
      "Cás Achomair"
    ],
    "then": [
      "* ",
      "Ansin"
    ],
    "when": [
      "* ",
      "Nuair a",
      "Nuair nach",
      "Nuair ba",
      "Nuair nár"
    ]
  },
  "gj": {
    "and": [
      "* ",
      "અને "
    ],
    "background": [
      "બેકગ્રાઉન્ડ"
    ],
    "but": [
      "* ",
      "પણ "
    ],
    "examples": [
      "ઉદાહરણો"
    ],
    "feature": [
      "લક્ષણ",
      "વ્યાપાર જરૂર",
      "ક્ષમતા"
    ],
    "given": [
      "* ",
      "આપેલ છે "
    ],
    "name": "Gujarati",
    "native": "ગુજરાતી",
    "scenario": [
      "સ્થિતિ"
    ],
    "scenarioOutline": [
      "પરિદ્દશ્ય રૂપરેખા",
      "પરિદ્દશ્ય ઢાંચો"
    ],
    "then": [
      "* ",
      "પછી "
    ],
    "when": [
      "* ",
      "ક્યારે "
    ]
  },
  "gl": {
    "and": [
      "* ",
      "E "
    ],
    "background": [
      "Contexto"
    ],
    "but": [
      "* ",
      "Mais ",
      "Pero "
    ],
    "examples": [
      "Exemplos"
    ],
    "feature": [
      "Característica"
    ],
    "given": [
      "* ",
      "Dado ",
      "Dada ",
      "Dados ",
      "Dadas "
    ],
    "name": "Galician",
    "native": "galego",
    "scenario": [
      "Escenario"
    ],
    "scenarioOutline": [
      "Esbozo do escenario"
    ],
    "then": [
      "* ",
      "Entón ",
      "Logo "
    ],
    "when": [
      "* ",
      "Cando "
    ]
  },
  "he": {
    "and": [
      "* ",
      "וגם "
    ],
    "background": [
      "רקע"
    ],
    "but": [
      "* ",
      "אבל "
    ],
    "examples": [
      "דוגמאות"
    ],
    "feature": [
      "תכונה"
    ],
    "given": [
      "* ",
      "בהינתן "
    ],
    "name": "Hebrew",
    "native": "עברית",
    "scenario": [
      "תרחיש"
    ],
    "scenarioOutline": [
      "תבנית תרחיש"
    ],
    "then": [
      "* ",
      "אז ",
      "אזי "
    ],
    "when": [
      "* ",
      "כאשר "
    ]
  },
  "hi": {
    "and": [
      "* ",
      "और ",
      "तथा "
    ],
    "background": [
      "पृष्ठभूमि"
    ],
    "but": [
      "* ",
      "पर ",
      "परन्तु ",
      "किन्तु "
    ],
    "examples": [
      "उदाहरण"
    ],
    "feature": [
      "रूप लेख"
    ],
    "given": [
      "* ",
      "अगर ",
      "यदि ",
      "चूंकि "
    ],
    "name": "Hindi",
    "native": "हिंदी",
    "scenario": [
      "परिदृश्य"
    ],
    "scenarioOutline": [
      "परिदृश्य रूपरेखा"
    ],
    "then": [
      "* ",
      "तब ",
      "तदा "
    ],
    "when": [
      "* ",
      "जब ",
      "कदा "
    ]
  },
  "hr": {
    "and": [
      "* ",
      "I "
    ],
    "background": [
      "Pozadina"
    ],
    "but": [
      "* ",
      "Ali "
    ],
    "examples": [
      "Primjeri",
      "Scenariji"
    ],
    "feature": [
      "Osobina",
      "Mogućnost",
      "Mogucnost"
    ],
    "given": [
      "* ",
      "Zadan ",
      "Zadani ",
      "Zadano "
    ],
    "name": "Croatian",
    "native": "hrvatski",
    "scenario": [
      "Scenarij"
    ],
    "scenarioOutline": [
      "Skica",
      "Koncept"
    ],
    "then": [
      "* ",
      "Onda "
    ],
    "when": [
      "* ",
      "Kada ",
      "Kad "
    ]
  },
  "ht": {
    "and": [
      "* ",
      "Ak ",
      "Epi ",
      "E "
    ],
    "background": [
      "Kontèks",
      "Istorik"
    ],
    "but": [
      "* ",
      "Men "
    ],
    "examples": [
      "Egzanp"
    ],
    "feature": [
      "Karakteristik",
      "Mak",
      "Fonksyonalite"
    ],
    "given": [
      "* ",
      "Sipoze ",
      "Sipoze ke ",
      "Sipoze Ke "
    ],
    "name": "Creole",
    "native": "kreyòl",
    "scenario": [
      "Senaryo"
    ],
    "scenarioOutline": [
      "Plan senaryo",
      "Plan Senaryo",
      "Senaryo deskripsyon",
      "Senaryo Deskripsyon",
      "Dyagram senaryo",
      "Dyagram Senaryo"
    ],
    "then": [
      "* ",
      "Lè sa a ",
      "Le sa a "
    ],
    "when": [
      "* ",
      "Lè ",
      "Le "
    ]
  },
  "hu": {
    "and": [
      "* ",
      "És "
    ],
    "background": [
      "Háttér"
    ],
    "but": [
      "* ",
      "De "
    ],
    "examples": [
      "Példák"
    ],
    "feature": [
      "Jellemző"
    ],
    "given": [
      "* ",
      "Amennyiben ",
      "Adott "
    ],
    "name": "Hungarian",
    "native": "magyar",
    "scenario": [
      "Forgatókönyv"
    ],
    "scenarioOutline": [
      "Forgatókönyv vázlat"
    ],
    "then": [
      "* ",
      "Akkor "
    ],
    "when": [
      "* ",
      "Majd ",
      "Ha ",
      "Amikor "
    ]
  },
  "id": {
    "and": [
      "* ",
      "Dan "
    ],
    "background": [
      "Dasar"
    ],
    "but": [
      "* ",
      "Tapi "
    ],
    "examples": [
      "Contoh"
    ],
    "feature": [
      "Fitur"
    ],
    "given": [
      "* ",
      "Dengan "
    ],
    "name": "Indonesian",
    "native": "Bahasa Indonesia",
    "scenario": [
      "Skenario"
    ],
    "scenarioOutline": [
      "Skenario konsep"
    ],
    "then": [
      "* ",
      "Maka "
    ],
    "when": [
      "* ",
      "Ketika "
    ]
  },
  "is": {
    "and": [
      "* ",
      "Og "
    ],
    "background": [
      "Bakgrunnur"
    ],
    "but": [
      "* ",
      "En "
    ],
    "examples": [
      "Dæmi",
      "Atburðarásir"
    ],
    "feature": [
      "Eiginleiki"
    ],
    "given": [
      "* ",
      "Ef "
    ],
    "name": "Icelandic",
    "native": "Íslenska",
    "scenario": [
      "Atburðarás"
    ],
    "scenarioOutline": [
      "Lýsing Atburðarásar",
      "Lýsing Dæma"
    ],
    "then": [
      "* ",
      "Þá "
    ],
    "when": [
      "* ",
      "Þegar "
    ]
  },
  "it": {
    "and": [
      "* ",
      "E "
    ],
    "background": [
      "Contesto"
    ],
    "but": [
      "* ",
      "Ma "
    ],
    "examples": [
      "Esempi"
    ],
    "feature": [
      "Funzionalità"
    ],
    "given": [
      "* ",
      "Dato ",
      "Data ",
      "Dati ",
      "Date "
    ],
    "name": "Italian",
    "native": "italiano",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Schema dello scenario"
    ],
    "then": [
      "* ",
      "Allora "
    ],
    "when": [
      "* ",
      "Quando "
    ]
  },
  "ja": {
    "and": [
      "* ",
      "かつ"
    ],
    "background": [
      "背景"
    ],
    "but": [
      "* ",
      "しかし",
      "但し",
      "ただし"
    ],
    "examples": [
      "例",
      "サンプル"
    ],
    "feature": [
      "フィーチャ",
      "機能"
    ],
    "given": [
      "* ",
      "前提"
    ],
    "name": "Japanese",
    "native": "日本語",
    "scenario": [
      "シナリオ"
    ],
    "scenarioOutline": [
      "シナリオアウトライン",
      "シナリオテンプレート",
      "テンプレ",
      "シナリオテンプレ"
    ],
    "then": [
      "* ",
      "ならば"
    ],
    "when": [
      "* ",
      "もし"
    ]
  },
  "jv": {
    "and": [
      "* ",
      "Lan "
    ],
    "background": [
      "Dasar"
    ],
    "but": [
      "* ",
      "Tapi ",
      "Nanging ",
      "Ananging "
    ],
    "examples": [
      "Conto",
      "Contone"
    ],
    "feature": [
      "Fitur"
    ],
    "given": [
      "* ",
      "Nalika ",
      "Nalikaning "
    ],
    "name": "Javanese",
    "native": "Basa Jawa",
    "scenario": [
      "Skenario"
    ],
    "scenarioOutline": [
      "Konsep skenario"
    ],
    "then": [
      "* ",
      "Njuk ",
      "Banjur "
    ],
    "when": [
      "* ",
      "Manawa ",
      "Menawa "
    ]
  },
  "kn": {
    "and": [
      "* ",
      "ಮತ್ತು "
    ],
    "background": [
      "ಹಿನ್ನೆಲೆ"
    ],
    "but": [
      "* ",
      "ಆದರೆ "
    ],
    "examples": [
      "ಉದಾಹರಣೆಗಳು"
    ],
    "feature": [
      "ಹೆಚ್ಚಳ"
    ],
    "given": [
      "* ",
      "ನೀಡಿದ "
    ],
    "name": "Kannada",
    "native": "ಕನ್ನಡ",
    "scenario": [
      "ಕಥಾಸಾರಾಂಶ"
    ],
    "scenarioOutline": [
      "ವಿವರಣೆ"
    ],
    "then": [
      "* ",
      "ನಂತರ "
    ],
    "when": [
      "* ",
      "ಸ್ಥಿತಿಯನ್ನು "
    ]
  },
  "ko": {
    "and": [
      "* ",
      "그리고"
    ],
    "background": [
      "배경"
    ],
    "but": [
      "* ",
      "하지만",
      "단"
    ],
    "examples": [
      "예"
    ],
    "feature": [
      "기능"
    ],
    "given": [
      "* ",
      "조건",
      "먼저"
    ],
    "name": "Korean",
    "native": "한국어",
    "scenario": [
      "시나리오"
    ],
    "scenarioOutline": [
      "시나리오 개요"
    ],
    "then": [
      "* ",
      "그러면"
    ],
    "when": [
      "* ",
      "만일",
      "만약"
    ]
  },
  "lt": {
    "and": [
      "* ",
      "Ir "
    ],
    "background": [
      "Kontekstas"
    ],
    "but": [
      "* ",
      "Bet "
    ],
    "examples": [
      "Pavyzdžiai",
      "Scenarijai",
      "Variantai"
    ],
    "feature": [
      "Savybė"
    ],
    "given": [
      "* ",
      "Duota "
    ],
    "name": "Lithuanian",
    "native": "lietuvių kalba",
    "scenario": [
      "Scenarijus"
    ],
    "scenarioOutline": [
      "Scenarijaus šablonas"
    ],
    "then": [
      "* ",
      "Tada "
    ],
    "when": [
      "* ",
      "Kai "
    ]
  },
  "lu": {
    "and": [
      "* ",
      "an ",
      "a "
    ],
    "background": [
      "Hannergrond"
    ],
    "but": [
      "* ",
      "awer ",
      "mä "
    ],
    "examples": [
      "Beispiller"
    ],
    "feature": [
      "Funktionalitéit"
    ],
    "given": [
      "* ",
      "ugeholl "
    ],
    "name": "Luxemburgish",
    "native": "Lëtzebuergesch",
    "scenario": [
      "Szenario"
    ],
    "scenarioOutline": [
      "Plang vum Szenario"
    ],
    "then": [
      "* ",
      "dann "
    ],
    "when": [
      "* ",
      "wann "
    ]
  },
  "lv": {
    "and": [
      "* ",
      "Un "
    ],
    "background": [
      "Konteksts",
      "Situācija"
    ],
    "but": [
      "* ",
      "Bet "
    ],
    "examples": [
      "Piemēri",
      "Paraugs"
    ],
    "feature": [
      "Funkcionalitāte",
      "Fīča"
    ],
    "given": [
      "* ",
      "Kad "
    ],
    "name": "Latvian",
    "native": "latviešu",
    "scenario": [
      "Scenārijs"
    ],
    "scenarioOutline": [
      "Scenārijs pēc parauga"
    ],
    "then": [
      "* ",
      "Tad "
    ],
    "when": [
      "* ",
      "Ja "
    ]
  },
  "mn": {
    "and": [
      "* ",
      "Мөн ",
      "Тэгээд "
    ],
    "background": [
      "Агуулга"
    ],
    "but": [
      "* ",
      "Гэхдээ ",
      "Харин "
    ],
    "examples": [
      "Тухайлбал"
    ],
    "feature": [
      "Функц",
      "Функционал"
    ],
    "given": [
      "* ",
      "Өгөгдсөн нь ",
      "Анх "
    ],
    "name": "Mongolian",
    "native": "монгол",
    "scenario": [
      "Сценар"
    ],
    "scenarioOutline": [
      "Сценарын төлөвлөгөө"
    ],
    "then": [
      "* ",
      "Тэгэхэд ",
      "Үүний дараа "
    ],
    "when": [
      "* ",
      "Хэрэв "
    ]
  },
  "nl": {
    "and": [
      "* ",
      "En "
    ],
    "background": [
      "Achtergrond"
    ],
    "but": [
      "* ",
      "Maar "
    ],
    "examples": [
      "Voorbeelden"
    ],
    "feature": [
      "Functionaliteit"
    ],
    "given": [
      "* ",
      "Gegeven ",
      "Stel "
    ],
    "name": "Dutch",
    "native": "Nederlands",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Abstract Scenario"
    ],
    "then": [
      "* ",
      "Dan "
    ],
    "when": [
      "* ",
      "Als "
    ]
  },
  "no": {
    "and": [
      "* ",
      "Og "
    ],
    "background": [
      "Bakgrunn"
    ],
    "but": [
      "* ",
      "Men "
    ],
    "examples": [
      "Eksempler"
    ],
    "feature": [
      "Egenskap"
    ],
    "given": [
      "* ",
      "Gitt "
    ],
    "name": "Norwegian",
    "native": "norsk",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Scenariomal",
      "Abstrakt Scenario"
    ],
    "then": [
      "* ",
      "Så "
    ],
    "when": [
      "* ",
      "Når "
    ]
  },
  "pa": {
    "and": [
      "* ",
      "ਅਤੇ "
    ],
    "background": [
      "ਪਿਛੋਕੜ"
    ],
    "but": [
      "* ",
      "ਪਰ "
    ],
    "examples": [
      "ਉਦਾਹਰਨਾਂ"
    ],
    "feature": [
      "ਖਾਸੀਅਤ",
      "ਮੁਹਾਂਦਰਾ",
      "ਨਕਸ਼ ਨੁਹਾਰ"
    ],
    "given": [
      "* ",
      "ਜੇਕਰ ",
      "ਜਿਵੇਂ ਕਿ "
    ],
    "name": "Panjabi",
    "native": "ਪੰਜਾਬੀ",
    "scenario": [
      "ਪਟਕਥਾ"
    ],
    "scenarioOutline": [
      "ਪਟਕਥਾ ਢਾਂਚਾ",
      "ਪਟਕਥਾ ਰੂਪ ਰੇਖਾ"
    ],
    "then": [
      "* ",
      "ਤਦ "
    ],
    "when": [
      "* ",
      "ਜਦੋਂ "
    ]
  },
  "pl": {
    "and": [
      "* ",
      "Oraz ",
      "I "
    ],
    "background": [
      "Założenia"
    ],
    "but": [
      "* ",
      "Ale "
    ],
    "examples": [
      "Przykłady"
    ],
    "feature": [
      "Właściwość",
      "Funkcja",
      "Aspekt",
      "Potrzeba biznesowa"
    ],
    "given": [
      "* ",
      "Zakładając ",
      "Mając ",
      "Zakładając, że "
    ],
    "name": "Polish",
    "native": "polski",
    "scenario": [
      "Scenariusz"
    ],
    "scenarioOutline": [
      "Szablon scenariusza"
    ],
    "then": [
      "* ",
      "Wtedy "
    ],
    "when": [
      "* ",
      "Jeżeli ",
      "Jeśli ",
      "Gdy ",
      "Kiedy "
    ]
  },
  "pt": {
    "and": [
      "* ",
      "E "
    ],
    "background": [
      "Contexto",
      "Cenário de Fundo",
      "Cenario de Fundo",
      "Fundo"
    ],
    "but": [
      "* ",
      "Mas "
    ],
    "examples": [
      "Exemplos",
      "Cenários",
      "Cenarios"
    ],
    "feature": [
      "Funcionalidade",
      "Característica",
      "Caracteristica"
    ],
    "given": [
      "* ",
      "Dado ",
      "Dada ",
      "Dados ",
      "Dadas "
    ],
    "name": "Portuguese",
    "native": "português",
    "scenario": [
      "Cenário",
      "Cenario"
    ],
    "scenarioOutline": [
      "Esquema do Cenário",
      "Esquema do Cenario",
      "Delineação do Cenário",
      "Delineacao do Cenario"
    ],
    "then": [
      "* ",
      "Então ",
      "Entao "
    ],
    "when": [
      "* ",
      "Quando "
    ]
  },
  "ro": {
    "and": [
      "* ",
      "Si ",
      "Și ",
      "Şi "
    ],
    "background": [
      "Context"
    ],
    "but": [
      "* ",
      "Dar "
    ],
    "examples": [
      "Exemple"
    ],
    "feature": [
      "Functionalitate",
      "Funcționalitate",
      "Funcţionalitate"
    ],
    "given": [
      "* ",
      "Date fiind ",
      "Dat fiind ",
      "Dati fiind ",
      "Dați fiind ",
      "Daţi fiind "
    ],
    "name": "Romanian",
    "native": "română",
    "scenario": [
      "Scenariu"
    ],
    "scenarioOutline": [
      "Structura scenariu",
      "Structură scenariu"
    ],
    "then": [
      "* ",
      "Atunci "
    ],
    "when": [
      "* ",
      "Cand ",
      "Când "
    ]
  },
  "ru": {
    "and": [
      "* ",
      "И ",
      "К тому же ",
      "Также "
    ],
    "background": [
      "Предыстория",
      "Контекст"
    ],
    "but": [
      "* ",
      "Но ",
      "А "
    ],
    "examples": [
      "Примеры"
    ],
    "feature": [
      "Функция",
      "Функциональность",
      "Функционал",
      "Свойство"
    ],
    "given": [
      "* ",
      "Допустим ",
      "Дано ",
      "Пусть "
    ],
    "name": "Russian",
    "native": "русский",
    "scenario": [
      "Сценарий"
    ],
    "scenarioOutline": [
      "Структура сценария"
    ],
    "then": [
      "* ",
      "То ",
      "Тогда "
    ],
    "when": [
      "* ",
      "Если ",
      "Когда "
    ]
  },
  "sk": {
    "and": [
      "* ",
      "A ",
      "A tiež ",
      "A taktiež ",
      "A zároveň "
    ],
    "background": [
      "Pozadie"
    ],
    "but": [
      "* ",
      "Ale "
    ],
    "examples": [
      "Príklady"
    ],
    "feature": [
      "Požiadavka",
      "Funkcia",
      "Vlastnosť"
    ],
    "given": [
      "* ",
      "Pokiaľ ",
      "Za predpokladu "
    ],
    "name": "Slovak",
    "native": "Slovensky",
    "scenario": [
      "Scenár"
    ],
    "scenarioOutline": [
      "Náčrt Scenáru",
      "Náčrt Scenára",
      "Osnova Scenára"
    ],
    "then": [
      "* ",
      "Tak ",
      "Potom "
    ],
    "when": [
      "* ",
      "Keď ",
      "Ak "
    ]
  },
  "sl": {
    "and": [
      "In ",
      "Ter "
    ],
    "background": [
      "Kontekst",
      "Osnova",
      "Ozadje"
    ],
    "but": [
      "Toda ",
      "Ampak ",
      "Vendar "
    ],
    "examples": [
      "Primeri",
      "Scenariji"
    ],
    "feature": [
      "Funkcionalnost",
      "Funkcija",
      "Možnosti",
      "Moznosti",
      "Lastnost",
      "Značilnost"
    ],
    "given": [
      "Dano ",
      "Podano ",
      "Zaradi ",
      "Privzeto "
    ],
    "name": "Slovenian",
    "native": "Slovenski",
    "scenario": [
      "Scenarij",
      "Primer"
    ],
    "scenarioOutline": [
      "Struktura scenarija",
      "Skica",
      "Koncept",
      "Oris scenarija",
      "Osnutek"
    ],
    "then": [
      "Nato ",
      "Potem ",
      "Takrat "
    ],
    "when": [
      "Ko ",
      "Ce ",
      "Če ",
      "Kadar "
    ]
  },
  "sr-Cyrl": {
    "and": [
      "* ",
      "И "
    ],
    "background": [
      "Контекст",
      "Основа",
      "Позадина"
    ],
    "but": [
      "* ",
      "Али "
    ],
    "examples": [
      "Примери",
      "Сценарији"
    ],
    "feature": [
      "Функционалност",
      "Могућност",
      "Особина"
    ],
    "given": [
      "* ",
      "За дато ",
      "За дате ",
      "За дати "
    ],
    "name": "Serbian",
    "native": "Српски",
    "scenario": [
      "Сценарио",
      "Пример"
    ],
    "scenarioOutline": [
      "Структура сценарија",
      "Скица",
      "Концепт"
    ],
    "then": [
      "* ",
      "Онда "
    ],
    "when": [
      "* ",
      "Када ",
      "Кад "
    ]
  },
  "sr-Latn": {
    "and": [
      "* ",
      "I "
    ],
    "background": [
      "Kontekst",
      "Osnova",
      "Pozadina"
    ],
    "but": [
      "* ",
      "Ali "
    ],
    "examples": [
      "Primeri",
      "Scenariji"
    ],
    "feature": [
      "Funkcionalnost",
      "Mogućnost",
      "Mogucnost",
      "Osobina"
    ],
    "given": [
      "* ",
      "Za dato ",
      "Za date ",
      "Za dati "
    ],
    "name": "Serbian (Latin)",
    "native": "Srpski (Latinica)",
    "scenario": [
      "Scenario",
      "Primer"
    ],
    "scenarioOutline": [
      "Struktura scenarija",
      "Skica",
      "Koncept"
    ],
    "then": [
      "* ",
      "Onda "
    ],
    "when": [
      "* ",
      "Kada ",
      "Kad "
    ]
  },
  "sv": {
    "and": [
      "* ",
      "Och "
    ],
    "background": [
      "Bakgrund"
    ],
    "but": [
      "* ",
      "Men "
    ],
    "examples": [
      "Exempel"
    ],
    "feature": [
      "Egenskap"
    ],
    "given": [
      "* ",
      "Givet "
    ],
    "name": "Swedish",
    "native": "Svenska",
    "scenario": [
      "Scenario"
    ],
    "scenarioOutline": [
      "Abstrakt Scenario",
      "Scenariomall"
    ],
    "then": [
      "* ",
      "Så "
    ],
    "when": [
      "* ",
      "När "
    ]
  },
  "ta": {
    "and": [
      "* ",
      "மேலும்  ",
      "மற்றும் "
    ],
    "background": [
      "பின்னணி"
    ],
    "but": [
      "* ",
      "ஆனால்  "
    ],
    "examples": [
      "எடுத்துக்காட்டுகள்",
      "காட்சிகள்",
      " நிலைமைகளில்"
    ],
    "feature": [
      "அம்சம்",
      "வணிக தேவை",
      "திறன்"
    ],
    "given": [
      "* ",
      "கொடுக்கப்பட்ட "
    ],
    "name": "Tamil",
    "native": "தமிழ்",
    "scenario": [
      "காட்சி"
    ],
    "scenarioOutline": [
      "காட்சி சுருக்கம்",
      "காட்சி வார்ப்புரு"
    ],
    "then": [
      "* ",
      "அப்பொழுது "
    ],
    "when": [
      "* ",
      "எப்போது "
    ]
  },
  "th": {
    "and": [
      "* ",
      "และ "
    ],
    "background": [
      "แนวคิด"
    ],
    "but": [
      "* ",
      "แต่ "
    ],
    "examples": [
      "ชุดของตัวอย่าง",
      "ชุดของเหตุการณ์"
    ],
    "feature": [
      "โครงหลัก",
      "ความต้องการทางธุรกิจ",
      "ความสามารถ"
    ],
    "given": [
      "* ",
      "กำหนดให้ "
    ],
    "name": "Thai",
    "native": "ไทย",
    "scenario": [
      "เหตุการณ์"
    ],
    "scenarioOutline": [
      "สรุปเหตุการณ์",
      "โครงสร้างของเหตุการณ์"
    ],
    "then": [
      "* ",
      "ดังนั้น "
    ],
    "when": [
      "* ",
      "เมื่อ "
    ]
  },
  "tl": {
    "and": [
      "* ",
      "మరియు "
    ],
    "background": [
      "నేపథ్యం"
    ],
    "but": [
      "* ",
      "కాని "
    ],
    "examples": [
      "ఉదాహరణలు"
    ],
    "feature": [
      "గుణము"
    ],
    "given": [
      "* ",
      "చెప్పబడినది "
    ],
    "name": "Telugu",
    "native": "తెలుగు",
    "scenario": [
      "సన్నివేశం"
    ],
    "scenarioOutline": [
      "కథనం"
    ],
    "then": [
      "* ",
      "అప్పుడు "
    ],
    "when": [
      "* ",
      "ఈ పరిస్థితిలో "
    ]
  },
  "tlh": {
    "and": [
      "* ",
      "'ej ",
      "latlh "
    ],
    "background": [
      "mo'"
    ],
    "but": [
      "* ",
      "'ach ",
      "'a "
    ],
    "examples": [
      "ghantoH",
      "lutmey"
    ],
    "feature": [
      "Qap",
      "Qu'meH 'ut",
      "perbogh",
      "poQbogh malja'",
      "laH"
    ],
    "given": [
      "* ",
      "ghu' noblu' ",
      "DaH ghu' bejlu' "
    ],
    "name": "Klingon",
    "native": "tlhIngan",
    "scenario": [
      "lut"
    ],
    "scenarioOutline": [
      "lut chovnatlh"
    ],
    "then": [
      "* ",
      "vaj "
    ],
    "when": [
      "* ",
      "qaSDI' "
    ]
  },
  "tr": {
    "and": [
      "* ",
      "Ve "
    ],
    "background": [
      "Geçmiş"
    ],
    "but": [
      "* ",
      "Fakat ",
      "Ama "
    ],
    "examples": [
      "Örnekler"
    ],
    "feature": [
      "Özellik"
    ],
    "given": [
      "* ",
      "Diyelim ki "
    ],
    "name": "Turkish",
    "native": "Türkçe",
    "scenario": [
      "Senaryo"
    ],
    "scenarioOutline": [
      "Senaryo taslağı"
    ],
    "then": [
      "* ",
      "O zaman "
    ],
    "when": [
      "* ",
      "Eğer ki "
    ]
  },
  "tt": {
    "and": [
      "* ",
      "Һәм ",
      "Вә "
    ],
    "background": [
      "Кереш"
    ],
    "but": [
      "* ",
      "Ләкин ",
      "Әмма "
    ],
    "examples": [
      "Үрнәкләр",
      "Мисаллар"
    ],
    "feature": [
      "Мөмкинлек",
      "Үзенчәлеклелек"
    ],
    "given": [
      "* ",
      "Әйтик "
    ],
    "name": "Tatar",
    "native": "Татарча",
    "scenario": [
      "Сценарий"
    ],
    "scenarioOutline": [
      "Сценарийның төзелеше"
    ],
    "then": [
      "* ",
      "Нәтиҗәдә "
    ],
    "when": [
      "* ",
      "Әгәр "
    ]
  },
  "uk": {
    "and": [
      "* ",
      "І ",
      "А також ",
      "Та "
    ],
    "background": [
      "Передумова"
    ],
    "but": [
      "* ",
      "Але "
    ],
    "examples": [
      "Приклади"
    ],
    "feature": [
      "Функціонал"
    ],
    "given": [
      "* ",
      "Припустимо ",
      "Припустимо, що ",
      "Нехай ",
      "Дано "
    ],
    "name": "Ukrainian",
    "native": "Українська",
    "scenario": [
      "Сценарій"
    ],
    "scenarioOutline": [
      "Структура сценарію"
    ],
    "then": [
      "* ",
      "То ",
      "Тоді "
    ],
    "when": [
      "* ",
      "Якщо ",
      "Коли "
    ]
  },
  "ur": {
    "and": [
      "* ",
      "اور "
    ],
    "background": [
      "پس منظر"
    ],
    "but": [
      "* ",
      "لیکن "
    ],
    "examples": [
      "مثالیں"
    ],
    "feature": [
      "صلاحیت",
      "کاروبار کی ضرورت",
      "خصوصیت"
    ],
    "given": [
      "* ",
      "اگر ",
      "بالفرض ",
      "فرض کیا "
    ],
    "name": "Urdu",
    "native": "اردو",
    "scenario": [
      "منظرنامہ"
    ],
    "scenarioOutline": [
      "منظر نامے کا خاکہ"
    ],
    "then": [
      "* ",
      "پھر ",
      "تب "
    ],
    "when": [
      "* ",
      "جب "
    ]
  },
  "uz": {
    "and": [
      "* ",
      "Ва "
    ],
    "background": [
      "Тарих"
    ],
    "but": [
      "* ",
      "Лекин ",
      "Бирок ",
      "Аммо "
    ],
    "examples": [
      "Мисоллар"
    ],
    "feature": [
      "Функционал"
    ],
    "given": [
      "* ",
      "Агар "
    ],
    "name": "Uzbek",
    "native": "Узбекча",
    "scenario": [
      "Сценарий"
    ],
    "scenarioOutline": [
      "Сценарий структураси"
    ],
    "then": [
      "* ",
      "Унда "
    ],
    "when": [
      "* ",
      "Агар "
    ]
  },
  "vi": {
    "and": [
      "* ",
      "Và "
    ],
    "background": [
      "Bối cảnh"
    ],
    "but": [
      "* ",
      "Nhưng "
    ],
    "examples": [
      "Dữ liệu"
    ],
    "feature": [
      "Tính năng"
    ],
    "given": [
      "* ",
      "Biết ",
      "Cho "
    ],
    "name": "Vietnamese",
    "native": "Tiếng Việt",
    "scenario": [
      "Tình huống",
      "Kịch bản"
    ],
    "scenarioOutline": [
      "Khung tình huống",
      "Khung kịch bản"
    ],
    "then": [
      "* ",
      "Thì "
    ],
    "when": [
      "* ",
      "Khi "
    ]
  },
  "zh-CN": {
    "and": [
      "* ",
      "而且",
      "并且",
      "同时"
    ],
    "background": [
      "背景"
    ],
    "but": [
      "* ",
      "但是"
    ],
    "examples": [
      "例子"
    ],
    "feature": [
      "功能"
    ],
    "given": [
      "* ",
      "假如",
      "假设",
      "假定"
    ],
    "name": "Chinese simplified",
    "native": "简体中文",
    "scenario": [
      "场景",
      "剧本"
    ],
    "scenarioOutline": [
      "场景大纲",
      "剧本大纲"
    ],
    "then": [
      "* ",
      "那么"
    ],
    "when": [
      "* ",
      "当"
    ]
  },
  "zh-TW": {
    "and": [
      "* ",
      "而且",
      "並且",
      "同時"
    ],
    "background": [
      "背景"
    ],
    "but": [
      "* ",
      "但是"
    ],
    "examples": [
      "例子"
    ],
    "feature": [
      "功能"
    ],
    "given": [
      "* ",
      "假如",
      "假設",
      "假定"
    ],
    "name": "Chinese traditional",
    "native": "繁體中文",
    "scenario": [
      "場景",
      "劇本"
    ],
    "scenarioOutline": [
      "場景大綱",
      "劇本大綱"
    ],
    "then": [
      "* ",
      "那麼"
    ],
    "when": [
      "* ",
      "當"
    ]
  }
}
